export enum EmployeeTaskStatusEnum
{
    New,
    Assigned,
    OnGoing,
    Closed,
    Inspected
}